<template>
  <div class="d-flex justify-content-center align-items-center w-100 h-100">
    <div class="font-size-h2 text-header-color text-center">SITE DOES NOT EXIST.</div>
  </div>
</template>

<script>
export default {
  name: 'KioskNoSite'
}
</script>
